import { WifiOff } from "lucide-react";
import { useNetworkStatus } from "@/hooks/useNetworkStatus";
import { Alert, AlertDescription } from "@/components/ui/alert";

export const OfflineIndicator = () => {
  const { isOffline } = useNetworkStatus();

  if (!isOffline) return null;

  return (
    <Alert variant="destructive" className="fixed top-4 left-4 right-4 z-50 animate-in slide-in-from-top">
      <WifiOff className="h-4 w-4" />
      <AlertDescription>
        No internet connection. Some features may be unavailable.
      </AlertDescription>
    </Alert>
  );
};
